import { useEffect, useState } from "react";
import { MoveRight } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

// Mobile-only sticky reservation pill — appears after scrolling past hero
export default function MobileStickyBookCTA() {
  const { t } = useLang();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      // Show after the user passes ~70% of the first viewport height
      setVisible(window.scrollY > window.innerHeight * 0.7);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <a
      href="#booking"
      data-testid="mobile-sticky-book"
      aria-hidden={!visible}
      className={`md:hidden fixed left-4 bottom-4 z-40 inline-flex items-center gap-2 bg-gold-600 text-cream-100 px-5 py-3 rounded-full text-sm shadow-[0_18px_40px_-12px_rgba(184,134,11,0.7)] border border-gold-500/40 transition-all duration-300
        ${visible ? 'opacity-100 translate-y-0 pointer-events-auto' : 'opacity-0 translate-y-6 pointer-events-none'}`}
    >
      {t.hero.cta_book} <MoveRight className="w-4 h-4" />
    </a>
  );
}
